export default "__VITE_ASSET__BbG7WNgE__"